<template>
    <div class="container-message-display">
        <div v-for="(message, index) in messages" :key="index" class="message-container">
            <PolygonMyMessage v-if="message.fromUserEmail === username" :message="message"/>
            <PolygonOtherMessage v-else :message="message" :isOtherMessage="true"/>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
    .quick-chat-container .container-message-display {
        background-color: white;
        flex: 1;
        overflow-y: scroll;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        min-height: 40vh;
        max-height: 40vh;
                /************** Safari 10.1+ ********************/
        @media not all and (min-resolution:.001dpcm)
        { @supports (-webkit-appearance:none) {

            .message-container{
                display:-webkit-box !important;
            }

        }}

        .message-image{
            padding: 6px 10px;
            border-radius: 15px;
            margin: 5px 0 5px 0;
            max-width: 70%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .message-image-display{
            width: 100%;
            border-radius: 5px;
            cursor:pointer;
            transition: 0.3s ease;
        }

        .message-image-display:hover{
            opacity: 0.8;
        }

        .message-text > p {
            margin: 5px 0 5px 0;
            font-size: 14px;
        }

        .my-message > .message-timestamp {
            text-align: right;
        }

        /* .my-message {
            justify-content: flex-end;
            padding-right: 15px;
            align-items: flex-end;
        } */

        .other-message {
            justify-content: flex-start;
            padding-left: 15px;
            align-items: flex-start;
        }

        .other-message > .message-text {
            color: #fff;
            border-bottom-left-radius: 0;
        }

        .my-message > .message-text {
            border-bottom-right-radius: 0;
        }

        .message-container {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
        }

        .message-username {
            font-size: 10px;
            font-weight: bold;
        }

        .icon-sent {
            padding-left: 5px;
            color: rgb(129, 127, 127);
        }

        .message-loading {
            height: 8px;
            width: 8px;
            border: 1px solid rgb(187, 183, 183);
            border-left-color: rgb(59, 59, 59);
            border-radius: 50%;
            margin-left: 5px;
            display: inline-block;
            animation: spin 1.3s ease infinite;
        }

        .img-loading{
            height: 20px;
            width: 20px;
            border: 3px solid #ffffff00;
            border-left-color: #847f7f;
            border-top-color: #847f7f;
            border-radius: 50%;
            margin-left: 5px;
            display: inline-block;
            -webkit-animation: spin 1.0s ease infinite;
            animation: spin 1.0s ease infinite;
            position: absolute;
        }

        .img-overlay{
            opacity: 0.4;
        }

        .message-username-image{
            margin: 10px 10px 0px 10px;
            font-size: 12px;
            font-weight: bold;
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
